import React from "react";
import type {FunctionComponent} from "react";
import {useWhenLessonInUserLibraryLogic} from "./WhenLessonInUserLibrary.logic";

export interface IWhenLessonInUserLibraryProps {
  lessonID: number;
}

export const WhenLessonInUserLibrary: FunctionComponent<IWhenLessonInUserLibraryProps> = ({lessonID, children}) => {
  const {isLessonInUserLibrary} = useWhenLessonInUserLibraryLogic(lessonID);
  if (!isLessonInUserLibrary){
    // not in user library
    return null;
  }
  return <>{children}</>;
}

